import { FormControlLabel, FormControl, RadioGroup, Radio } from '@mui/material';
import { RequestVM } from 'civil-status/view-models/step-form';
import { useFormikContext } from 'formik';
import { memo, useMemo } from 'react';

interface RadioRequestProps {
  request?: RequestVM;
  disabled?: boolean;
}

const RadioRequestComponent = ({ request, disabled }: RadioRequestProps): React.ReactElement => {
  const formContext = useFormikContext<Record<string, string | boolean>>();

  const name = request?.name || '';

  const error = useMemo(() => {
    return (
      formContext.touched &&
      formContext.touched[name] &&
      formContext.errors &&
      Boolean(formContext.errors[name])
    );
  }, [formContext.touched, formContext.errors]);

  return (
    <span>
      <div style={{ color: error ? '#d32f2f' : '' }}>{request?.request} *</div>
      <FormControl component="fieldset">
        <RadioGroup
          row
          aria-label={request?.request}
          id={request?.request}
          value={formContext.values[name]}
          onChange={(event) => {
            formContext.setValues({
              ...(formContext.values || {}),
              [name]: event.target.value || '',
            });
          }}
        >
          {request?.options?.map((item) => (
            <FormControlLabel
              disabled={disabled}
              key={request.name + item.id}
              value={item.id}
              control={<Radio />}
              label={item.value || ''}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </span>
  );
};

RadioRequestComponent.displayName = 'Radio Request component';

const RadioRequest = memo(RadioRequestComponent);

export default RadioRequest;
